module.exports = __webpack_public_path__ + "img/chaomengjihua.32d5e70e.jpg";